<template>
  <div class="wia-container">
    <div class="wia-box">
      <h2 class="wia-title">{{config.i18n.wia_title}}</h2>
      <div class="wia-select wia-select--categories">
        <span class="wia-label">{{config.i18n.wia_need_help}} </span><span class="wia-label__strong">{{categorySelected.text}}</span>
        <span class="wia-label__back" v-on:click="backHome()"> {{config.i18n.wia_back}}</span>
      </div>
      <div class="wia-select wia-select--categories" v-if="modelSelected && modelSelected.sku != null">
        <span class="wia-label">{{config.i18n.wia_model_name}} </span>
        <span class="wia-label__strong">{{modelSelected.code}}</span>
      </div>
    </div>

    <v-wia-input-auto
      v-if="isFreeSearchEnabled()"
      :groups="groups"
      @input="onInputWIAAuto"
      @select="onSelectWIAAuto"
      @reset="onResetWIAAuto"
    >
    </v-wia-input-auto>

    <div class="wia-box wia-box__light wia-box__result" v-show="issueSelected.text || subIssueSelected.text || specificIssueSelected.text">
      <div class="wia-select wia-select--categories wia-issues-result">
        <div class="wia-label__group">
          <h2 class="wia-title wia-title__black">{{config.i18n.wia_issue_concern}} </h2>
          <span class="wia-label__back" v-on:click="back()"> {{config.i18n.wia_back}}</span>
        </div>
        <span class="wia-label__strong" v-show="issueSelected.text">{{issueSelected.text}}</span>
        <span class="wia-label__strong" v-show="subIssueSelected.text">{{subIssueSelected.text}}</span>
        <span class="wia-label__strong" v-show="specificIssueSelected.text">{{specificIssueSelected.text}}</span>
      </div>
    </div>
    <div class="wia-box wia-box__light wia-issue-final-step-title">
      <div class="wia-label__group wia-label__group--nomargin">
        <h2 class="wia-title wia-title__black">{{config.i18n.wia_possible_solution}}</h2>
      </div>
      <div class="wia-solutions">
        <div v-for="option in resultOptions" class="wia-solution-container" v-bind:value="option.id" v-bind:key="option.id">
          <div class="wia-result">
            <span class="wia-result__title">{{option.check}}</span>
            <span class="wia-result__description">{{option.verify}}</span>
            <div class="wia-smile-icon-container">
              {{config.i18n.wia_solved_issue}}
              <div class="wia-smile-icon">
                <span class="wia-smile-up-icon" @click="toggleSmileUpPopup(option.id)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                    <g>
                      <path
                        d="M15 30a15 15 0 1115-15 15.017 15.017 0 01-15 15zm0-27.979A12.979 12.979 0 1027.982 15 12.993 12.993 0 0015 2.021z"
                      ></path>
                    </g>
                    <g>
                      <path
                        d="M15.071 24.208a16.973 16.973 0 01-8.777-2.671 1.087 1.087 0 011.249-1.778c.325.227 7.936 5.411 14.827-.544a1.087 1.087 0 111.421 1.644 13.031 13.031 0 01-8.72 3.349z"
                      ></path>
                    </g>
                    <g>
                      <g>
                        <circle
                          cx="2.178"
                          cy="2.178"
                          transform="translate(7.259 9.56)"
                          r="2.178"
                        ></circle>
                      </g>
                      <g>
                        <circle
                          cx="2.178"
                          cy="2.178"
                          transform="translate(18.385 9.56)"
                          r="2.178"
                        ></circle>
                      </g>
                    </g>
                  </svg>
                </span>
                <span class="wia-smile-down-icon" @click="toggleSmileDownPopup(option.id)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                    <g>
                      <path
                        d="M6.861 22.477a1.086 1.086 0 01-.71-1.909c8.2-7.07 17.406-.723 17.5-.658a1.087 1.087 0 01-1.251 1.777c-.321-.224-7.926-5.422-14.828.527a1.084 1.084 0 01-.711.263z"
                      ></path>
                    </g>
                    <g>
                      <path
                        d="M15 30a15 15 0 1115-15 15.017 15.017 0 01-15 15zm0-27.979A12.979 12.979 0 1027.982 15 12.993 12.993 0 0015 2.021z"
                      ></path>
                    </g>
                    <g>
                      <g>
                        <circle
                          cx="2.179"
                          cy="2.179"
                          transform="translate(7.259 9.559)"
                          r="2.179"
                        ></circle>
                      </g>
                      <g>
                        <circle
                          cx="2.178"
                          cy="2.178"
                          transform="translate(18.385 9.56)"
                          r="2.178"
                        ></circle>
                      </g>
                    </g>
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="noSolution" class="wia-issues wia-issues--noresults">
      <a v-bind:href="link" class="wia-title wia-title__black wia-title__underline">{{config.i18n.wia_no_solution}} </a>
    </div>
    <div class="wia-popup" v-show="showPopup" v-on:click.self="togglePopup(actualId)" >
      <div class="wia-popup__container" v-bind:value="actualId">
        <div class="wia-popup__header" v-on:click="togglePopup(actualId)">
          <h2>{{config.i18n.wia_closed}}</h2>
        </div>
        <div class="wia-popup__content">
          <div class="wia-popup__text" v-show="feedbackSelected === null">
            <h3 class="wia-title wia-title__black"> {{config.i18n.wia_solved_issue}}</h3>
            <div class="wia-popup__solution">
              <span class="wia-popup__solution--title">{{actualtTitle}} </span>
              <span class="wia-popup__solution--desc">{{actualtDesc}} </span>
            </div>
            <div class="wia-popup__actions">
              <button type="submit" class="wia-form__button button btn-change wia-form__button--secondary"
                      :data-id="actualId" :data-category="categorySelected.id" data-gtm="select-feedback" v-on:click="selectFeedback(); dataLayerSelfHelpChoice(config.i18n.wia_feedback_ok);">
                {{config.i18n.wia_feedback_ok}}
              </button>
              <span class="wia-label__back" v-on:click="togglePopup(actualId); dataLayerSelfHelpChoice(config.i18n.wia_find_another_solution);">
                {{config.i18n.wia_find_another_solution}}
              </span>
            </div>
          </div>
          <div class="wia-popup__text" v-show="feedbackSelected">
            <h3 class="wia-title wia-title__black"> {{config.i18n.wia_feedback_title}}</h3>
            <div class="wia-popup__success">
              <div class="wia-popup__success-text">
                <span>{{config.i18n.wia_feedback_text1}}</span>
              </div>
              <div class="wia-popup__success-text">
                <span>{{config.i18n.wia_feedback_text2}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wia-popup" v-show="showSmileUpPopup" v-on:click.self="toggleSmileUpPopup()">
      <div class="wia-popup__container">
        <div class="wia-popup__header" v-on:click="toggleSmileUpPopup()">
          <h2>{{config.i18n.wia_closed}}</h2>
        </div>
        <div class="wia-popup__content">
          <div class="wia-popup__text">
            <h3 class="wia-title wia-title__black">{{config.i18n.wia_feedback_title}}</h3>
            <a class="wia-form__button button btn-change wia-form__button--secondary"
              v-if="!hidePositiveCTA"
               target="_blank"
               @click="handlePositiveCTAClickAction()"
               :href="getExternalLink(this.$store.state.config.brand.toLowerCase(), this.$store.state.config.country.toLowerCase(), 'warranty_page')">
               {{config.i18n.wia_smile_up_popup_text1}}
               </a>
          </div>
        </div>
      </div>
    </div>
    <div class="wia-popup" v-show="showSmileDownPopup" v-on:click.self="toggleSmileDownPopup()">
      <div class="wia-popup__container">
        <div class="wia-popup__header" v-on:click="toggleSmileDownPopup()">
          <h2>{{config.i18n.wia_closed}}</h2>
        </div>
        <div class="wia-popup__content">
          <div class="wia-popup__text">
            <h3 class="wia-title wia-title__black">{{config.i18n.wia_smile_down_popup_title}}</h3>
            <div class="wia-popup__buttons-container">
              <a class="wia-form__button button btn-change wia-form__button--secondary"
                @click="goToFirstStep()">
              {{config.i18n.wia_find_another_solution}}
              </a>
              <p class="wia-popup__or-text">{{config.i18n.wia_smile_down_popup_or_text}}</p>
              <a class="wia-form__button button btn-change wia-form__button--secondary"
                target="_blank"
                @click="handleNegativeCTAClickAction()"
                :href="getExternalLink(this.$store.state.config.brand.toLowerCase(), this.$store.state.config.country.toLowerCase(), 'book_an_intervention_page')">
                {{config.i18n.wia_smile_down_popup_text2}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {getMetaBrand, getMetaCountry, getMetaStaticByTag} from '@/helpers/seoMetatagInfo'
import { from } from 'rxjs'
import { map, switchMap, concatMap, toArray, take } from 'rxjs/operators'
import autocompleteMixin from '../mixin/autocompleteMixin'
import {getExternalLink} from '@/helpers/getExternalLink'

export default {
  name: 'WIAResult',
  head: {
    link: [
      {
        rel: 'canonical',
        href: document.location.href
      }
    ]
  },
  title () {
    return `${this.getQueryStringValue('productLine')} ${this.getMetaBrand()} — ${this.getQueryStringValue('problemName').replace(/-+/g, ' ')} | ${this.getMetaBrand()} ${this.getMetaCountry()}`
  },
  description () {
    return `${this.getQueryStringValue('problemName').replace(/-+/g, ' ')} ${this.getQueryStringValue('productLine')} ${this.getMetaBrand()}: ${this.getMetaStaticByTag('description')}.`
  },
  canonical () {
    return document.location.href
  },
  meta: {
    name: 'robots',
    content: 'index'
  },
  data () {
    return {
      categorySelected: '',
      modelSelected: '',
      issueSelected: '',
      subIssueSelected: '',
      specificIssueSelected: '',
      feedbackSelected: null,
      resultOptions: [],
      showPopup: false,
      showSmileUpPopup: false,
      showSmileDownPopup: false,
      actualId: 0,
      groups: [],
      link: '',
      actualtTitle: '',
      actualtDesc: '',
      error: '',
      noSolution: false,
      currentOption: ''
    }
  },
  created () {
    this.$watch(() => this.$route.query, (newQuery) => {
      newQuery.problemID && !this.$store.state.details.resultOptions.length && this.getSolutions(newQuery.problemID)
    })
    this.$watch(() => this.$store.state.details.resultOptions, (newResultOptions) => {
      this.resultOptions = newResultOptions
    })
  },
  computed: {
    config: function () {
      return this.$store.state.config
    },
    ...mapState({
      errors: state => state.auth.errors
    }),
    detail: function () {
      return this.$store.state.details
    },
    hidePositiveCTA: function () {
      return ['DK', 'FI', 'NO', 'SE'].includes(this.$store.state.config.country.toUpperCase())
    }
  },
  mixins: [autocompleteMixin],
  methods: {
    getExternalLink: getExternalLink,
    selectFeedback () {
      this.feedbackSelected = this.actualId
    },
    back () {
      this.$router.push({
        name: 'WIAStep3',
        query: {
          productLine: this.categorySelected.id,
          product: this.modelSelected.code,
          macroCat: this.issueSelected.id,
          cat: this.subIssueSelected.id,
          problem: this.specificIssueSelected.id
        }
      })
    },
    backHome () {
      this.$store.commit('resetData')
      this.$router.push({
        name: 'WIA-Home'
      })
    },
    backResetHome () {
      this.$store.commit('resetAll')
      this.$router.push({
        name: 'WIA-Home'
      })
    },
    togglePopup (id, title, desc) {
      this.actualId = id
      this.actualtTitle = title
      this.actualtDesc = desc
      if (this.feedbackSelected && this.showPopup) {
        this.backResetHome()
      }
      document.querySelector('.wia-container').scrollIntoView()
      this.showPopup = !this.showPopup
    },
    getlink  () {
      const brand = this.$store.state.config.brand
      const contactLinks = this.config.i18n.wia_contact_links

      this.link = contactLinks && contactLinks[brand] ? contactLinks[brand] : ''
    },
    getQueryStringValue (key) {
      // eslint-disable-next-line
      return decodeURIComponent(window.location.href.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"))
    },
    getCategory (categoryCode) {
      // /product_line/{language}
      this.$http.get(this.$store.state.config.endpoint + '/product_line/' + this.$store.state.config.language.toLowerCase()).then(
        result => {
          var category = result.body
          var item = category.findIndex(x => x.description === categoryCode)
          if (item !== -1) {
            this.categorySelected = {'id': category[item].id, 'text': categoryCode}
            return 1
          }
          return -1
        })
    },
    getProduct (productCode) {
      // /models/{q}
      this.$http.get(this.$store.state.config.endpoint + '/models/' + productCode).then(
        result => {
          var products = result.body
          var item = products.filter(x => x.model === productCode)
          if (item !== -1) {
            this.modelSelected = {'sku': item[0].id, 'code': productCode}
            return 1
          }
          return -1
        }, error => {
          this.errormsg = error.body
        })
    },
    getL1Issue (issueCode) {
      // /macro_categories/{language}
      this.$http.get(this.$store.state.config.endpoint + '/macro_categories/' + this.$store.state.config.language.toLowerCase()).then(
        result => {
          var L1Issues = result.body
          var item = L1Issues.findIndex(x => x.id === issueCode)
          if (item !== -1) {
            this.issueSelected = {'id': issueCode, 'text': L1Issues[item].description}
            return 1
          }
          return -1
        })
    },
    getL2Issue (issueCode, categoryCode, L1Issue) {
      // /categories/{language}/{productLine}/{macroCategory}
      this.$http.get(this.$store.state.config.endpoint + '/categories/' + this.$store.state.config.language.toLowerCase() + '/' + categoryCode + '/' + L1Issue).then(
        result => {
          var L2Issues = result.body
          var item = L2Issues.findIndex(x => x.id === issueCode)
          if (item !== -1) {
            this.subIssueSelected = {'id': issueCode, 'text': L2Issues[item].description}
            return 1
          }
          return -1
        })
    },
    getL3Issue (issueCode, L2Issue) {
      // /problems/{language}/{category}/{brand}/{country}
      this.$http.get(this.$store.state.config.endpoint + '/problems/' + this.$store.state.config.language.toLowerCase() + '/' + L2Issue + '/IND/' + this.$store.state.config.country).then(
        result => {
          var L3Issues = result.body
          var item = L3Issues.findIndex(x => x.id === issueCode)
          if (item !== -1) {
            this.specificIssueSelected = {'id': issueCode, 'text': L3Issues[item].text}
            return 1
          }
          return -1
        })
    },
    getBrand () {
      switch (this.$store.state.config.brand) {
        case 'WP':
          return '/021/'
        case 'ID':
          return '/IND/'
        case 'HP':
          return '/HOT/'
        case 'BK':
          return '/011/'
      }
    },
    getMetaBrand () {
      return getMetaBrand(this.$store.state.config.brand.toLowerCase())
    },
    getMetaCountry () {
      return getMetaCountry(this.$store.state.config.brand.toLowerCase(), this.$store.state.config.i18n || {})
    },
    getMetaStaticByTag (tag) {
      return getMetaStaticByTag(tag, this.$store.state.config.brand.toLowerCase(), this.$store.state.config.i18n || {})
    },
    dataLayerServiceSelfHelp (issue) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'serviceSelfHelp',
        'serviceIssue': issue
      })
    },
    dataLayerSelfHelpChoice (choice) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'selfHelpChoice',
        'popupChoice': choice
      })
    },

    toggleSmileUpPopup (optionId) {
      this.currentOption = optionId
      if (!this.showSmileUpPopup) {
        this.pushOnDataLayerGA4('feedback', 'positive')
        this.pushTroubleshootingFeedback('positive', optionId)
      }
      this.showSmileUpPopup = !this.showSmileUpPopup
    },
    toggleSmileDownPopup (optionId) {
      this.currentOption = optionId
      if (!this.showSmileDownPopup) {
        this.pushOnDataLayerGA4('feedback', 'negative')
        this.pushTroubleshootingFeedback('negative', optionId)
      }
      this.showSmileDownPopup = !this.showSmileDownPopup
    },
    goToFirstStep () {
      this.$router.push({name: 'WIAStep1',
        query: {
          productLine: this.categorySelected.id,
          product: this.modelSelected.code
        }})
      document.querySelector('.wia-container').scrollIntoView()
      let text = 'Find another solution'
      let href = document.location.href
      this.pushOnDataLayerGA4('CTA', 'negative', href, text)
      this.pushFunReq09('try other solutions', this.currentOption)
    },
    getRelatedSolutions (problemIDs) {
      const getSolutions$ = problemID => from(this.$http.get(`${this.$store.state.config.endpoint}/check_and_resolve/${this.$store.state.config.language.toLowerCase()}/${problemID}/IND/${this.$store.state.config.country}`))
        .pipe(map(response => response.body), switchMap(from))

      from(problemIDs)
        .pipe(
          concatMap(getSolutions$),
          take(this.relatedSolutionsMaxCount),
          toArray()
        )
        .subscribe(relatedSolutions => {
          this.relatedSolutions = relatedSolutions
        })
    },

    getSolutions (problemID) {
      this.$http.get(`${this.$store.state.config.endpoint}/check_and_resolve/${this.$store.state.config.language.toLowerCase()}/${problemID}/IND/${this.$store.state.config.country}`).then(
        result => {
          this.resultOptions = result.body
          if (this.resultOptions.length <= 0) {
            this.getlink()
            this.noSolution = true
            let meta = {
              name: 'robots',
              content: 'noindex'
            }
            let metaObj = document.createElement('meta')
            metaObj.name = meta.name
            metaObj.content = meta.content
            document.getElementsByTagName('head')[0].appendChild(metaObj)
          }
        }, error => {
          this.error = error.body
          this.noSolution = true
        })
    },
    handlePositiveCTAClickAction () {
      let text = 'Discover our protection plans'
      let href = this.getExternalLink(this.$store.state.config.brand.toLowerCase(), this.$store.state.config.country.toLowerCase(), 'warranty_page')
      this.pushOnDataLayerGA4('CTA', 'positive', href, text)
      this.pushFunReq09('discover protection plans', this.currentOption)
    },
    handleNegativeCTAClickAction () {
      let text = 'Book an intervention'
      let href = getExternalLink(this.$store.state.config.brand.toLowerCase(), this.$store.state.config.country.toLowerCase(), 'book_an_intervention_page')
      this.pushOnDataLayerGA4('CTA', 'negative', href, text)
      this.pushFunReq09('book a visit', this.currentOption)
    },
    pushFunReq09 (troubleshootingFeedback, optionId) {
      let troubleShootingIssue = document.querySelector('.wia-issues-result .wia-label__strong:last-child').innerHTML
      if (troubleShootingIssue === '' && document.querySelector('.input-autocomplete__input-field')) {
        troubleShootingIssue = document.querySelector('.input-autocomplete__input-field').value
      }
      window.dataLayer.push({
        'event': 'troubleshooting_feedback_cta',
        'troubleshooting_feedback': troubleshootingFeedback,
        'troubleshooting_issue': troubleShootingIssue,
        'troubleshooting_resolution_id': optionId
      })
    },
    pushTroubleshootingFeedback (feedback, optionId) {
      let troubleShootingIssue = document.querySelector('.wia-issues-result .wia-label__strong:last-child').innerHTML
      if (troubleShootingIssue === '' && document.querySelector('.input-autocomplete__input-field')) {
        troubleShootingIssue = document.querySelector('.input-autocomplete__input-field').value
      }
      window.dataLayer.push({
        'event': 'troubleshooting_feedback',
        'troubleshooting_feedback': feedback,
        'troubleshooting_issue': troubleShootingIssue,
        'troubleshooting_resolution_id': optionId
      })
    },
    pushOnDataLayerGA4 (type, feedback, linkUrl = '', linkText = '') {
      let currentDate = new Date()
      let formattedDate = currentDate.toISOString().replace('T', ' ').replace('Z', ' UTC')
      let problemDescription = ''
      if (this.issueSelected && this.issueSelected.text) {
        problemDescription = this.issueSelected.text
      }
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'problems_solutions_feedback',
        'type': type,
        'feedback': feedback,
        'link_url': linkUrl,
        'link_text': linkText,
        'request_timestamp': formattedDate,
        'problem_description': problemDescription
      })
    }
  },
  mounted () {
    window.dataLayer = window.dataLayer || []

    setTimeout(function () {
      const urlParams = new URLSearchParams(window.location.search)
      const itemCategory = urlParams.get('productLine')
      let troubleShootingIssue = document.querySelector('.wia-issues-result .wia-label__strong:last-child').innerHTML
      if (troubleShootingIssue === '' && document.querySelector('.input-autocomplete__input-field')) {
        troubleShootingIssue = document.querySelector('.input-autocomplete__input-field').value
      }
      window.dataLayer.push({
        'event': 'troubleshooting_funnel',
        'step_number': 2,
        'step_name': 'Possible solutions',
        'troubleshooting_issue': troubleShootingIssue,
        'item_category3': itemCategory
      })
    }, 1500)
    let url = document.location.pathname + document.location.search
    url = url.replace('--step1', '')
    url = url.replace('--step2', '')
    url = url.replace('--step3', '')
    history.pushState('', '', url)
    var categoryCode = this.getQueryStringValue('productLine')
    var sku = this.getQueryStringValue('product')
    var L1Issue = this.getQueryStringValue('macroCat')
    var L2Issue = this.getQueryStringValue('cat')
    var L3Issue = this.getQueryStringValue('problemID')

    // Check for category
    if (this.$store.state.details.category !== null) {
      this.categorySelected = this.$store.state.details.category
    } else {
      if (categoryCode.length > 0) {
        this.getCategory(categoryCode)
      }
    }

    // Check for sku
    if (this.$store.state.details.model) {
      this.modelSelected = this.$store.state.details.model
    } else {
      if (sku.length > 0) {
        this.modelSelected = {'sku': sku, 'code': null}
      } else {
        this.modelSelected = {'sku': null, 'code': null}
      }
    }
    // Check for L1Issue
    if (this.$store.state.details.issue !== null) {
      this.issueSelected = this.$store.state.details.issue
    } else {
      if (L1Issue.length > 0) {
        this.getL1Issue(L1Issue)
      }
    }

    // Check for L2Issue
    if (this.$store.state.details.subIssue !== null) {
      this.subIssueSelected = this.$store.state.details.subIssue
    } else {
      if (L2Issue.length > 0) {
        setTimeout(() => this.getL2Issue(L2Issue, this.categorySelected.id, L1Issue), 100)
      }
    }

    // Check for L3Issue
    if (this.$store.state.details.specificIssue !== null) {
      this.specificIssueSelected = this.$store.state.details.specificIssue
    } else {
      if (L3Issue.length > 0 && L2Issue.length > 0) {
        this.getL3Issue(L3Issue, L2Issue)
      }
    }

    // Check for autocomplete suggestion groups
    if (this.$store.state.details.groups !== null) {
      this.groups = this.$store.state.details.groups
    }

    // Check for solutions
    if (this.$store.state.details.resultOptions !== null) {
      this.resultOptions = this.$store.state.details.resultOptions
    }

    if (this.categorySelected !== null) {
      this.getlink()
      if (this.modelSelected.sku === null || this.modelSelected.sku === undefined) {
        // /check_and_resolve/{language}/{problem}/{brand}/{country}
        if (L3Issue && (!this.$store.state.details.resultOptions || !this.$store.state.details.resultOptions.length)) {
          this.getSolutions(L3Issue)
        }
      } else {
        // /check_and_resolve_by_product/{language}/{problem}/{product}/{category}/{brand}/{country}
        this.$http.get(this.$store.state.config.endpoint + '/check_and_resolve_by_product/' + this.$store.state.config.language.toLowerCase() + '/' + L3Issue + '/' + this.modelSelected.sku + '/' + categoryCode + this.getBrand() + this.$store.state.config.country).then(
          result => {
            this.resultOptions = result.body
            if (this.resultOptions.length <= 0) {
              this.getlink()
              this.noSolution = true
            }
          }, error => {
            this.error = error.body
            this.noSolution = true
          })
        // problem 1221
        // brand IND
        // country IT
        // product F028908
        // category LVB00402
        // this.$http.get('https://api.wia.staging.wpsandwatch.com/check_and_resolve_by_product/' + this.$store.state.config.country.toLowerCase() + '/1221/F028908/LVB00402/IND/' + this.$store.state.config.country).then(
        //   result => {
        //     this.resultOptions = result.body
        //   })
      }
      // this.$store.state.config.brand = 'IND'
    } else {
      this.$router.push({
        name: 'WIA-Home'
      })
    }
    if (window.dataLayer) {
      // window.dataLayer.push({
      //   'event': 'WIAPageView',
      //   'eventAction': document.location.href
      // })
    } else {
      console.log(document.location.href)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../style/main.scss';
  .wia-solution-container{
    &.selected{
      .wia-icon {
        color: #4aa408;
        svg {
          fill: #4aa408;
        }
      }
    }
  }
  .wia-title{
    &__underline{
      display: block;
      &:hover {
       color: #0090d0;
      }
    }
  }
  .wia-icon{
    cursor: pointer;
    flex-direction: row;
    align-items: center;
    margin-right: 15px;
    margin-left: 15px;
    display: flex;

    &.selected{
      color: #4aa408;
      svg {
        fill: #4aa408;
      }
    }

    &:hover{
      svg {
        fill: #4aa408;
      }
    }

    svg{
      width: 35px;
      height: 24px;
      fill: #4aa408;
      transition: all .4s ease;

    }

    &__rotate{
      @media (min-width: $desktop) {
        display: none;
      }
      &.selected{
        svg {
          fill: #b50018;
        }
      }
      &:hover{
        svg {
          fill: #b50018;
        }
      }
      svg {
        transform: rotate(180deg);
      }
    }
  }

  .wia-box{
    &__light{
      padding-top: 0;
      background-color: white;
      padding-bottom: 25px;
    }

    &__result{
      padding: 50px;
      padding-left: 0;
      padding-right: 0;
    }
  }

  .wia-label{
    &__strong{
      text-align: center;
    }
  }

  .wia-select{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    &__wrapper{
      flex: 0 0 auto;
      width: auto !important;
      position: relative;
    }

    &__item{
      padding-bottom: 0 !important;
      font-size: 32px;
      position: relative;
      &::after{
        content: "";
        display: block;
        width: 6px;
        height: 6px;
        border: solid #3e3e40;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg) translate(-110%,-20%);
        position: absolute;
        top: 50%;
        right: 3px;
        z-index: 0;
      }
    }
  }

  .wia-issues{
    max-width: 68rem;
    margin: 0 auto;

    &__full{
      max-width: none;
      text-align: center;
    }
  }

  .wia-issue-container{
    margin-bottom: 25px;
    border: 1px solid rgba(177,179,182,0.4);
    background: #fff;
    display: block;
    box-sizing: border-box;
    padding: 2.5rem;
    -webkit-transition: all .2s;
    transition: all .2s;
    &:hover{
      color: #fff;
      background: #0090d0;
      cursor: pointer;
    }
    &.selected{
      color: #fff;
      background: #0090d0;
    }

    &__static:hover{
      background: #fff;
      color: initial;
      cursor: initial;
    }
    &__static{
      margin-bottom: 0;
    }
  }

  .wia-issues-result{
    max-width: 68rem;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
    .wia-label__strong{
      margin-right: 0;
      margin-top: 5px !important;
      margin-bottom: 5px;
      font-size: 18px;
      @media (min-width: $desktop) {
        font-size: 24px;
        margin-bottom: 10px;
      }
    }
  }

  .wia-result{
    height: 100%;
    border: 1px solid rgba(177,179,182,0.4);
    background: #f9f9f9;
    color: #3e3e40;
    box-sizing: border-box;
    width: 100%;
    padding: 15px;
    margin: 15px;
    align-items: center;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: space-between;

    &__title{
      font-size: 20px;
      padding-bottom: 10px;
      @media (min-width: $desktop) {
        min-height: 85px;
      }
    }

    &__description{
      font-size: 16px;
      padding-bottom: 10px;
      @media (min-width: $desktop) {
        min-height: 133px;
      }
    }
  }

  .wia-solutions{
    max-width: 1024px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .wia-solution-container{
    display: flex;
    flex: 0 0 100%;
    margin-bottom:15px;
    @media (min-width: $desktop) {
      flex: 0 0 33%;
      min-height: 300px;
    }
    position: relative;
    flex-grow: 1;

    .wia-icon-container{
      padding: 1.4rem 2rem;
      border-radius: 5px;
      border: 1px solid #0090d0;
      position: relative;
      font-size: 16px;
      cursor: pointer;
      text-align: center;

      &:hover{
        background-color: #0090d0;
        color: white;
      }
    }

    &:nth-child(2n){
      .wia-result {
        border: 1px solid rgba(177, 179, 182, 0.4);
        background: #f9f9f9;
        color: #3e3e40;
        height: 100%;
      }

      .wia-icon-container{
        border: 1px solid #0090d0;
        &:hover{
          background-color: #0090d0;
          color: white;
        }
      }
    }
  }

  .wia-popup {
    display: flex;
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    background: rgba(55,72,78,.9);
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    z-index: 999;

    &__header{
      color: #ffffff;
      padding-bottom: 10px;
      text-align: right;
      padding-right: 15px;
      cursor: pointer;
      h2{
        color: #ffffff;
        margin-bottom: 0;
        margin-top: 0;
      }
    }

    &__container{
      position: absolute;
      z-index: 99999;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%,-50%);
      -ms-transform: translate(-50%,-50%);
      transform: translate(-50%,-50%);
      max-width: 600px;
      width: 90%;
      max-height: 80vh;
      overflow: auto;

      &--opacity{
        opacity: 0.3;
      }
    }

    &__actions {
      display: flex;
      margin-top: 25px;
      justify-content: center;
      flex-direction: row;
      flex-wrap: wrap;

      .wia-label__back{
        margin-left: 25px;
      }
    }

    &__content{
      text-align: center;
      padding: 25px; //it was 32px. To fix de_DE locale issue
      background-color: #ffffff;
      a {
        text-decoration: none;
      }
    }

    &__success{
      display: flex;
    }
    &__success-text{
      text-align: center;
    }

    .wia-title{
      margin-bottom: 25px;
      font-size: 30px;
    }

    &__or-text {
      margin: 10px 0;
    }

    &__solution{
      display: flex;
      align-items: center;
      flex-direction: column;

      &--title{
        font-size: 20px;
        padding-bottom: 10px;
        text-align: center;
      }

      &--desc{
        font-size: 16px;
        padding-bottom: 10px;
        text-align: center;
      }
    }

    &__buttons-container{
      display:flex;
      flex-direction: column;
    }

  }

  .wia-label__group{
    margin-bottom: 25px;
    width: 100%;
    .wia-title{
      margin-bottom: 0;
    }
  }

  .wia-label__group--nomargin{
    margin-bottom: 10px;
  }

  .brand-theme-id{
    .wia-title{
      &__underline{
        font-family: robotolight !important;
      }
    }
  }

  .brand-theme-hp{
    .wia-solution-container .wia-icon-container {
      padding: 1.4rem 2rem;
      border-radius: 0;
      border: 1px solid #1fa2ac;
      position: relative;
      font-size: 16px;
      cursor: pointer;
      text-align: center;

      &:hover{
        background-color: #1fa2ac;
        border: 1px solid #1fa2ac;
        color: white;
      }
    }

    .wia-title__underline:hover {
      color: #1fa2ac;
    }

    .wia-label__back{
      margin-top: 0;
    }
  }

  .brand-theme-mb{
    .wia-solution-container .wia-icon-container {
      padding: 1.4rem 2rem;
      border-radius: 0;
      border: 1px solid  map-get($colors, main-button-background-mb);
      position: relative;
      font-size: 16px;
      cursor: pointer;
      text-align: center;

      &:hover{
        background-color:  map-get($colors, main-button-background-mb);
        border: 1px solid  map-get($colors, main-button-background-mb);
        color: white;
      }
    }

    .wia-title__underline:hover {
      color:  map-get($colors, main-button-background-mb);
    }

    .wia-label__back{
      margin-top: 0;
    }
  }

  .brand-theme-bk{
    .wia-solution-container .wia-icon-container {
      padding: 1.4rem 2rem;
      border-radius: 0;
      border: 1px solid #1fa2ac;
      position: relative;
      font-size: 16px;
      cursor: pointer;
      text-align: center;

      &:hover{
        background-color: #1fa2ac;
        border: 1px solid #1fa2ac;
        color: white;
      }
    }

    .wia-title__underline:hover {
      color: #1fa2ac;
    }

    .wia-label__back{
      margin-top: 0;
    }
  }

  .brand-theme-wp{
    .wia-solution-container .wia-icon-container {
      padding: 1.4rem 2rem;
      border-radius: 0;
      border: 1px solid #edb112;
      position: relative;
      font-size: 16px;
      cursor: pointer;
      text-align: center;

      &:hover{
        background-color: #edb112;
        border: 1px solid #edb112;
        color: white;
      }
    }

    .wia-title__underline:hover {
      color: #edb112;
    }

    .wia-label__back{
      margin-top: 0;
    }
  }

  .brand-theme-wp-2020{
    .wia-solution-container .wia-icon-container {
      border: 1px solid #edb112;
      &:hover{
        background-color: #edb112;
        border: 1px solid #edb112;
        color: white;
      }
    }
    .wia-title__underline:hover {
      color: #edb112;
    }
  }

  .wia-smile-icon-container {
    padding: 1.4rem 2rem;
    border-radius: 5px;
    position: relative;
    font-size: 16px;
    cursor: pointer;
    text-align: center;
    .wia-smile-icon {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-right: 15px;
      margin-left: 15px;
      margin-top: 10px;
      svg {
        width: 70px;
        height: 48px;
        cursor: pointer;
      }
    }
    .wia-smile-icon {
      svg:hover {
        transform: scale(1.2);
      }
    }
  }

</style>
